import React, { useEffect, useState } from 'react'

import styled, { css } from 'styled-components'

import UserInfoMenu from 'components/UserInfoMenu'

import Brand from 'helpers/brand'

import { color } from 'styles/colors'
import Spinner from 'components/Spinner'
import { useFeaturesContext } from 'hooks/FeaturesContext'

type Props = {
  displayMiniVariantSidebar: boolean
}

const Header = ({ displayMiniVariantSidebar }: Props) => {
  const { tier, areFeaturesLoaded } = useFeaturesContext()
  const [premium, setPremium] = useState<boolean>(false)
  const isPremiumMiniLogo = premium && displayMiniVariantSidebar

  useEffect(() => {
    if (tier === 'premium' && areFeaturesLoaded) {
      setPremium(true)
    } else {
      setPremium(false)
    }
  }, [tier, areFeaturesLoaded])

  if (!areFeaturesLoaded) {
    return <Spinner variant="page" />
  }

  const logoSrc = premium
    ? displayMiniVariantSidebar
      ? Brand.premiumProductMeatballPath()
      : Brand.premiumProductLogoPath()
    : displayMiniVariantSidebar
      ? Brand.faviconPath()
      : Brand.productLogoPath()

  return (
    <S.Header>
      <S.ProductLogo
        isPremiumMiniLogo={isPremiumMiniLogo}
        src={logoSrc}
        aria-label="product-logo"
        alt={`${Brand.productName()} logo`}
      />
      <S.UserInfoMenu displayMiniVariantSidebar={displayMiniVariantSidebar} />
    </S.Header>
  )
}

export default Header

const S = {
  ProductLogo: styled.img.withConfig({
    shouldForwardProp: (prop) => prop !== 'isPremiumMiniLogo'
  })<{ isPremiumMiniLogo?: boolean }>`
    display: flex;
    height: 33px;
    margin-bottom: 38px;
    justify-content: center;

    ${({ isPremiumMiniLogo }) =>
    isPremiumMiniLogo &&
      css`
        height: 50px;
        width: 50px;
      `}
  `,
  Header: styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    margin: 20px 0px 20px 0px;
  `,
  UserInfoMenu: styled(UserInfoMenu)`
    color: ${color('primaryText')};
    font-size: 16px;
  `
}
